import Svg, { SvgProps, Path } from 'react-native-svg';
import { memo } from 'react';
const SvgComponent = (props: SvgProps) => (
  <Svg fill="none" viewBox="0 0 48 100" {...props}>
    <Path d="M24 0 .906 40h46.188L24 0Zm4 100V36h-8v64h8Z" />
  </Svg>
);
const Memo = memo(SvgComponent);
export default Memo;
